/* unplugin-vue-components disabled */import script from "./jumpIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./jumpIndex.vue?vue&type=script&setup=true&lang=js"

import "./jumpIndex.vue?vue&type=style&index=0&id=86b26d72&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86b26d72"]])

export default __exports__